@if (initialized) {
  <div class="row">
    <div>&nbsp;</div>
    <div class="icons">
      <button mat-icon-button [disabled]="!('create' | able: newInternalTest)" (click)="openEdit(newInternalTest)"
        title="Add onsite test" color="accent">
        <mat-icon>add</mat-icon>
      </button>
    </div>
  </div>
  @if (!internalTests.length) {
    <div class="mat-body-strong">
      Found no onsite tests for this project.
      @if (('create' | able: newInternalTest)) {
        <a class="mat-inline-button" color="accent"
          (click)="openEdit(newInternalTest)" aria-label="Add onsite test" title="Add onsite test">Add onsite test?
        </a>
      }
    </div>
  }
  <!-- list -->
  <div class="list">
    @for (internalTest of internalTests; track internalTest) {
      <div class="list-card">
        <!-- actions -->
        <div class="hover-icons">
          <a mat-mini-fab [disabled]="!('update' | able: internalTest)" (click)="openEdit(internalTest)" color="accent"
            aria-label="Edit {{internalTest.name}}" title="Edit {{internalTest.name}}">
            <mat-icon>edit</mat-icon>
          </a>
          <button mat-mini-fab [disabled]="!('delete' | able: internalTest)" (click)="delete(internalTest)" color="warn"
            aria-label="Delete {{internalTest.name}}" title="Delete {{internalTest.name}}">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
        <!-- /actions -->
        <div class="body">
          <div class="mat-headline-6 row">
            <div class="mat-body-strong">
              {{internalTest.name}}
              @if (internalTest.record_by_station) {
                <span class="mat-caption">(by station)</span>
              }
            </div>
            <div>
              <div>
                <span class="mat-body-strong">Fields: </span>
                @if (!internalTest?.fields?.length) {
                  None
                }
              </div>
              @if (internalTest?.fields?.length) {
                <div>
                  @for (field of internalTest?.fields; track field) {
                    <div>
                      <span class="mat-body-strong">{{field.label}}</span>
                      <span class="mat-caption"> ({{field.type}})</span>
                    </div>
                  }
                </div>
              }
            </div>
            <div>
              <div>
                <span class="mat-body-strong">Bid items: </span>
                @if (!internalTest?.bid_items?.length) {
                  None
                }
              </div>
              @if (internalTest?.bid_items?.length) {
                <div>
                  @for (bidItem of internalTest?.bid_items; track bidItem) {
                    <div>{{bidItem.item}}</div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <!-- ./list -->
  @if (initialized && pagination.length && internalTests.length) {
    <mat-paginator (page)="pageChanged($event)"
      [length]="pagination.length" [pageIndex]="pagination.pageIndex" [pageSize]="pagination.pageSize">
    </mat-paginator>
  }
}